module.exports = ".create-progress{padding:10px 18px}\n"